import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDevice = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 80 80"
    {...props}
  >
    <rect width={80} height={80} fill="#1E6CE1" rx={40} />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M22 48V30.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C25.04 24 26.16 24 28.4 24h23.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C58 27.04 58 28.16 58 30.4V48H47.325c-.489 0-.733 0-.964.055-.203.05-.399.13-.578.24-.201.123-.374.296-.72.642l-.126.126c-.346.346-.519.519-.72.642q-.271.165-.578.24c-.23.055-.475.055-.965.055h-5.349c-.489 0-.733 0-.964-.055-.203-.05-.399-.13-.578-.24-.201-.123-.374-.296-.72-.642l-.126-.126c-.346-.346-.519-.519-.72-.642a2 2 0 0 0-.578-.24c-.23-.055-.475-.055-.965-.055zm0 0a2 2 0 0 0-2 2v.667c0 1.24 0 1.86.136 2.368a4 4 0 0 0 2.829 2.829c.508.136 1.128.136 2.368.136h29.334c1.24 0 1.86 0 2.368-.136a4 4 0 0 0 2.829-2.829c.136-.508.136-1.128.136-2.368 0-.62 0-.93-.068-1.185a2 2 0 0 0-1.414-1.414C58.263 48 57.953 48 57.333 48H56"
    />
  </svg>
);
export default SvgDevice;
